import { render, staticRenderFns } from "./perfilEmpresa.vue?vue&type=template&id=25a82964&scoped=true&"
import script from "./perfilEmpresa.vue?vue&type=script&lang=js&"
export * from "./perfilEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a82964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a82964')) {
      api.createRecord('25a82964', component.options)
    } else {
      api.reload('25a82964', component.options)
    }
    module.hot.accept("./perfilEmpresa.vue?vue&type=template&id=25a82964&scoped=true&", function () {
      api.rerender('25a82964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/vistas/perfilEmpresa.vue"
export default component.exports